<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 tabindex="0">Alterar Transmissão</h1>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group label="Título:">
                <b-input-group class="mb-3">
                  <b-form-input type="text"
                                class="form-control"
                                placeholder="Título"
                                autocomplete="titulo"
                                v-model="$v.form.titulo.$model"
                                :state="chkState('titulo')"
                                autofocus/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group label="Data da Transmissão:">
                <b-input-group class="mb-3">
                  <b-form-input v-mask='"##/##/####"'
                                type="text"
                                class="form-control"
                                placeholder="Data da Transmissão"
                                autocomplete="data"
                                v-model="$v.form.data.$model"
                                :state="chkState('data')"
                                autofocus/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Data da transmissão é obrigatória.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group label="Inserir Horário de Transmissão:">
                  <b-form-radio-group v-model="$v.form.possui_hora.$model" :state="chkState('possui_hora')" id="radio-slots" :options="options_horario" name="radio-options-slots"/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6" v-if="form.possui_hora">
              <b-form-group label="Hora de Início Transmissão:">
                <b-input-group class="mb-3">
                  <b-form-input v-mask='"##:##"'
                                type="text"
                                class="form-control"
                                placeholder="Hora da Transmissão"
                                autocomplete="hora"
                                v-model="$v.form.hora.$model"
                                :state="chkState('hora')"
                                autofocus/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Hora de início é obrigatória.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6" v-if="form.possui_hora">
              <b-form-group label="Hora de Término Transmissão:">
                <b-input-group class="mb-3">
                  <b-form-input v-mask='"##:##"'
                                type="text"
                                class="form-control"
                                placeholder="Hora de Término Transmissão"
                                autocomplete="hora_termino"
                                v-model="$v.form.hora_termino.$model"
                                :state="chkState('hora_termino')"
                                autofocus/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Hora de término é obrigatória.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group label="Habilitar Comentários:">
                <b-form-radio-group v-model="$v.form.permite_comentarios.$model" :state="chkState('permite_comentarios')" id="radio-slots2" :options="options_permite_comentarios" name="radio-options-slots2"/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group label="Habilitar Live:">
                <b-form-radio-group v-model="$v.form.aovivo.$model" :state="chkState('aovivo')" id="radio-slots3" :options="options_aovivo" name="radio-options-slots3"/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group label="Url do Vídeo:" :state="chkState('url')">
                  <b-form-input type="text"
                                class="form-control"
                                placeholder="Url do Vídeo"
                                autocomplete="url"
                                v-model="$v.form.url.$model"
                                :disabled="disable_url"
                                :state="chkState('url')"
                                autofocus/>
                <b-form-invalid-feedback id="input1LiveFeedback9">Url do vídeo é obrigatória.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group label="Url da Live:" :state="chkState('url_facebook')">
                  <b-form-input type="text"
                                class="form-control"
                                placeholder="Url da Live"
                                autocomplete="url_facebook"
                                :disabled="disable_url_facebook"
                                v-model="$v.form.url_facebook.$model"
                                :state="chkState('url_facebook')"
                                autofocus/>
                <b-form-invalid-feedback id="input1LiveFeedback9">Url da live é obrigatória.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
             <b-col sm="12" md="12" lg="6">
                 <b-form-group label="Canal:">
                  <b-form-select :disabled="!form.aovivo" v-model.trim="$v.form.canal.$model" :state="chkState('canal')"
                                 placeholder="Canal" class="mb-3">
                    <option value="null" selected> Selecione </option>
                    <option v-for="item in options_canal" :key="item.value" :value="item.value"> {{item.text}}</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback9">Canal é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="12" lg="6">
              <b-form-group label="Banner do Vídeo: * (.jpg, .jpeg ou .png)" for="banner">               
                <b-form-file id="banner" :disabled="form.aovivo"  ref="banner"  v-on:change="uploadFile" :state="chkState('banner')" placeholder="Escolha um arquivo..." accept="image/jpeg, image/png" browse-text="Selecionar"/>
                <span v-if="mostra_banner"><a :href="$v.form.banner.$model" target="_blank">banner_video.jpeg</a></span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading" sm="12" md="4" lg="3" style="padding-bottom: 5px;">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-plus"></i>&nbsp;
              <span>Alterar Transmissão</span>
            </b-button>
          </b-col>
          <b-col v-else sm="12" md="4" lg="3" style="padding-bottom: 5px;">
            <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Salvando...
            </b-button>
          </b-col>
          <b-col sm="12" md="4" lg="3">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/sala')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      data: {
        required
      },
      hora: {
        required: requiredIf(function () {
          return this.form.possui_hora
        })
      },
      hora_termino: {
        required: requiredIf(function () {
          return this.form.possui_hora
        })
      },
      url: {
        required: requiredIf(function () {
          return !this.form.aovivo
        })
      },
      url_facebook: {
        required: requiredIf(function () {
          return this.form.aovivo
        })
      },
      possui_hora: {
        required
      },
      permite_comentarios: {
        required
      },
      aovivo: {
        required
      },
      canal: {
         required: requiredIf(function () {
          return this.form.aovivo
        })
      },
      banner: {
         required: requiredIf(function () {
          return !this.form.aovivo
        })
      },
    }
  },
  created () {
    if (!this.validaPerfil()) {
      this.$router.push('/')
    }
    this.loadSala(this.$route.params.id)
  },
  data () {
    return {
      loading: false,
      form: {
        titulo: '',
        data: '',
        hora: '',
        url: '',
        url_facebook: '',
        atual: false,
        possui_hora: false,
        permite_comentarios: false,
        aovivo: false,
        canal: null,
        banner: null
      },
      mostra_banner: false,
      options_transmissao: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false }
      ],
      options_horario: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false }
      ],
      options_permite_comentarios: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false }
      ],
      options_aovivo: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false }
      ],
      options_canal: [
        { text: 'Facebook', value: 'F'},
        { text: 'YouTube', value: 'Y' }
      ],
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false,
      disable_url_facebook: true,
      disable_url: false
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  watch: {
    'form.aovivo': function () {      
      if(this.form.aovivo){
        this.disable_url_facebook = false
        this.disable_url = true
        this.$v.form.url.$model = ''  
        this.$v.form.banner.$model = null 
      }else{
        this.disable_url_facebook = true
        this.disable_url = false
        this.$v.form.url_facebook.$model = ''
        this.$v.form.canal.$model = null
      }
    },
  },
  methods: {
    validaPerfil () {
      let perfil = this.$store.state.perfil.perfil     
      if (perfil.is_admin_conferencia) {
        return true
      }
      return false
    },
    loadSala (id) {
      Vue.http.get('api/salaTransmissao/' + id).then(response => {
     
        let data = response.body.data[0]       
       
        this.form.titulo = data.titulo
        this.form.url = data.url_video
        this.form.url_facebook = data.url_facebook
        this.form.atual = data.atual
        if(data.banner !== null){
          this.mostra_banner = true
        }
        this.form.banner = data.banner
        this.form.canal = data.canal

        let dataHora = data.data_hora
  
        let dataTransmissao = dataHora.split(' ')
        this.form.data = dataTransmissao

        if (data.data_hora_termino) {
          let horaTransmissao = dataHora.split(' ')[1]
          this.form.hora = horaTransmissao

          let dataHoraTermino = data.data_hora_termino
          if (dataHoraTermino) {
            let horaTransmissaoTermino = dataHoraTermino.split(' ')[1]
            this.form.hora_termino = horaTransmissaoTermino
          }

          this.form.possui_hora = true
        } else {
          this.form.possui_hora = false
        }

        this.form.permite_comentarios = data.permite_comentarios ? data.permite_comentarios : false
        this.form.aovivo = data.aovivo
      })
    },
    salvar () {
      let form = this.$v.form
      let dataTransmissao = form.data.$model
      dataTransmissao = dataTransmissao.split('/')
      dataTransmissao = dataTransmissao[2] + '-' + dataTransmissao[1] + '-' + dataTransmissao[0]

      let data = {
        titulo: form.titulo.$model,
        atual: this.form.atual,
        url_video: form.url.$model,
        url_facebook: form.url_facebook.$model,
        permite_comentarios: form.permite_comentarios.$model,
        aovivo: form.aovivo.$model,
        banner: form.banner.$model,
        canal: form.canal.$model
      }
      this.loading = true

      if (form.possui_hora.$model) {
        data.data_hora = dataTransmissao + ' ' + form.hora.$model
        data.data_hora_termino = dataTransmissao + ' ' + form.hora_termino.$model
      } else {
        data.data_hora = dataTransmissao
        data.data_hora_termino = null
      }

      Vue.http.put('api/salaTransmissao/' + this.$route.params.id, data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({path: '/sala'})
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    uploadFile(evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (arquivo[0].size > 25000000) {
        this.$refs['banner'].reset()
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Tamanho máximo permitido para o arquivo é 25Mb.', 'Alerta', 5000)
        return false
      }

      let extensionesPermitidas = ['png','jpg', 'jpeg']
      let ext = arquivo[0].name.split('.').pop()
      let permitida = false

      for (var i = 0; i < extensionesPermitidas.length; i++) {
        if (extensionesPermitidas[i] === ext) {
          permitida = true
          break
        }
      }

      if (!permitida) {
        this.$refs['banner'].reset()
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Tipo de arquivo não permitido', 'Alerta', 5000)       
        return false
      }

      if (!arquivo.length) {
        return false
      } 

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.$v.form.banner.$model = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])

       this.mostra_banner = false
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/salas/SalaEditar.vue